<template>
	<v-container fluid class="mb-4">
		<v-toolbar text dark color="secondary">
			<v-toolbar-title>Informações</v-toolbar-title>
		</v-toolbar>

		<v-form ref="form" v-model="IsFormValid">
			<v-container>
				<v-sheet elevation="2" class="pa-4">
					<v-container>
						<v-text-field v-model="Informacoes.professor_titular" label="Nome do Professor titular" :disabled="!isAdmin" :rules="[InputRules.required]"></v-text-field>
					</v-container>

					<v-container>
						<v-textarea v-model="Informacoes.observacoes"
							label="Observações / notas"
							clearable counter="2000"
							hint="Indique informação relevante sobre esta turma."
							:disabled="!isAdmin"
							:rules="[InputRules.maxChars]">
						</v-textarea>
					</v-container>

					<div class="my-8">
						<v-layout d-flex justify-end>
							<v-tooltip bottom v-if="isAdmin">
								<template v-slot:activator="{ on }">
									<v-btn text color="primary" v-on="on" :disabled="!IsFormValid" @click="saveInformacoes">
										<v-icon left>save</v-icon>
										Gravar
									</v-btn>
								</template>
								<span>Gravar informações</span>
							</v-tooltip>
						</v-layout>

						<p class="text-end red--text" v-show="!IsFormValid">Existem erros de validação.</p>
					</div>
				</v-sheet>
			</v-container>
		</v-form>

		<v-divider></v-divider>

        <v-btn color="primary" text class="my-8" @click="goBack()">
            <v-icon left>arrow_back</v-icon>
            Voltar
        </v-btn>

		<v-snackbar v-model="Snackbar.show" bottom right vertical :timeout="5000">
			{{ Snackbar.message }}
			<v-btn text @click="Snackbar.show = false">Fechar</v-btn>
		</v-snackbar>

		<ErrorDialog :show-dialog="this.errorMessage.show" :error-message="this.errorMessage"></ErrorDialog>
	</v-container>
</template>

<script>
    import Vue from 'vue'
	import StaticData from '@/data/static-data.js';
	Vue.use(StaticData);

	import UserService from '@/services/user.service';
	const userService = new UserService();

	import ErrorDialog from '@/components/ErrorDialog';

    export default {
		components: {
			ErrorDialog
		},

        data: () => ({
			errorMessage: {
				show: false
			},
			IsFormValid: true,
			Informacoes: {
				professor_titular: null,
				observacoes: null
			},
            InputRules: {
                required: value => !!value || 'Campo obrigatório',
                maxChars: value => !value || value.length <= 2000 || 'Deverá conter no máximo 2000 caracteres'
			},
			Snackbar: {
				show: false,
				message: 'Informação registada com sucesso.'
			},
        }),

        created () {
			this.turmaId = this.$route.params.turmaId;
			this.loadInformacoes();
        },

        computed: {
			isAdmin () {
				return userService.isAdmin();
			}
        },

        methods: {
			loadInformacoes () {
				this.$http.get(process.env.VUE_APP_API_ROOT + `/turma-informacoes?turma=${this.turmaId}`).then(function(data){
                    return data.json();
                }).then(function(data){
					console.log("data", data);
					
					if (data && data.length == 1) {
						this.Informacoes = data[0];
					}
                });
			},
			saveInformacoes () {
				console.log("Informacoes", this.Informacoes);
				if (this.Informacoes.id) {
					this.$http.put(process.env.VUE_APP_API_ROOT + `/turma-informacoes/${this.Informacoes.id}/`, this.Informacoes).then(function(data){
						console.log(data);

						this.Snackbar.show = true;
					}, response => { // error callback
						console.log(response);

						this.errorMessage.message = "Ocorreu um erro ao editar ao gravar os dados.";
						this.errorMessage.show = true;
					});
				}
				else {
					this.Informacoes.turma = this.turmaId;

					this.$http.post(process.env.VUE_APP_API_ROOT + '/turma-informacoes/', this.Informacoes).then(function(data){
						console.log(data);

						this.Informacoes = data.body;

						this.Snackbar.show = true;
						// console.log("Informacoes", this.Informacoes);
					}, response => { // error callback
						console.log(response);

						this.errorMessage.message = "Ocorreu um erro ao editar ao gravar os dados.";
						this.errorMessage.show = true;
					});
                }
			},
			goBack () {
                window.history.length > 1
                    ? this.$router.go(-1)
                    : this.$router.push('/')
            }
        },
    }
</script>